import './SeriesFilterItem.scss'

import classNames from 'classnames'
import AdminContext from 'lib/context/AdminContext'
import { buildQueryString, KeyVal, QUERY_KEYS } from 'lib/util/routing'
import Series from 'pages/Home/Series'
import React, { LiHTMLAttributes, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'

import SeriesAdminControls from './admin/SeriesAdminControls'

export interface SeriesFilterItemProps extends RouteComponentProps, LiHTMLAttributes<HTMLLIElement> {
  clearQueryKeys?: string[]
  openDeleteSeriesDialog?: (series: Series)=> void
  openEditSeriesDialog?: (series: Series)=> void
  selectedSeries?: Series
  series?: Series
}

export default withRouter(function(props: SeriesFilterItemProps) {
  const { clearQueryKeys = [], location, openDeleteSeriesDialog, openEditSeriesDialog, series, selectedSeries } = props
  const { showAdminControls } = useContext(AdminContext)
  const [t] = useTranslation()
  const itemClassName = 'series-filter-item'

  if (!series) {
    const allClassName = classNames(itemClassName, { selected: !selectedSeries })

    return (
      <li className={allClassName}>
        <Link
          className="series-filter-item__content"
          to={{ search: buildQueryString(location, [[QUERY_KEYS.series]]) }}>
          {t('home.series.all.name')}
        </Link>
      </li>
    )
  }

  const className = classNames(itemClassName, {
    selected: selectedSeries && selectedSeries.id === series.id,
    [`${itemClassName}--unpublished`]: !series.published
  })

  return (
    <li className={className}>
      <Link
        className="series-filter-item__content"
        to={{
          search: buildQueryString(location, [
            [QUERY_KEYS.series, series.title],
            ...clearQueryKeys.map(key => [key] as KeyVal)
          ])
        }}>
        {series.title}
      </Link>
      {showAdminControls && (
        <SeriesAdminControls
          openDeleteSeriesDialog={openDeleteSeriesDialog}
          openEditSeriesDialog={openEditSeriesDialog}
          series={series}
        />
      )}
    </li>
  )
})
